export { LegalAgreementNotice } from "#legal-agreement-notice";
export { PrivacyDocumentBody } from "#privacy-document-body";
export { TermsDocumentBody } from "#terms-document-body";
